<template>
  <div id="maintenanceList">
    <div class="title_bar">
      <div class="left" />
      <div class="right">
        <el-button
          icon="icon-cashRecord"
          round
          @click="clickBudget"
        >
          長期修繕預算預估
        </el-button>
        <el-button
          icon="icon-mobile-qr"
          round
          @click="clickGetQRCode"
        >
          維養 QRCode
        </el-button>
        <el-button
          icon="icon-plus"
          round
          @click="clickAdd"
        >
          新增
        </el-button>
      </div>
    </div>
    <el-table
      class="newslist"
      :data="listData"
      empty-text="目前無維養計畫"
    >
      <el-table-column
        type="index"
        width="50"
      />
      <el-table-column
        v-for="[key, val] of Object.entries(maintenanceListStructure) "
        :key="key"
        :prop="key"
        :label="val"
      />
      <el-table-column
        label="操作"
        width="120px"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            @click="clickView(scope.row.Id)"
          >
            檢視
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      v-if="isLoading"
      class="promptText"
    >
      <div class="spinner">
        <div class="bounce1" />
        <div class="bounce2" />
        <div class="bounce3" />
      </div>
    </div>
    <ChooseSupplierDialog
      ref="chooseSupplierDialog"
      :supplier-list="supplierList"
      @selectSupplier="onSelectSupplier"
    />
    <SupplierQRCodeDialog ref="supplierQrCodeDialog" />
    <MaintenanceYearDialog ref="maintenanceYearDialog" />
  </div>
</template>
<script>
import { maintenanceListStructure } from './models'
import ChooseSupplierDialog from './components/ChooseSupplierDialog'
import SupplierQRCodeDialog from './components/SupplierQRCodeDialog'
import MaintenanceYearDialog from './components/MaintenanceYearDialog'
export default {
  components: {
    ChooseSupplierDialog,
    SupplierQRCodeDialog,
    MaintenanceYearDialog
  },
  data () {
    return {
      isLoading: false,
      listData: [],
      maintenanceListStructure,
      supplierList: [],
      maxCount: 10,
      offset: 0,
      isEnd: false
    }
  },
  async mounted () {
    if (!JSON.parse(localStorage.getItem('loginUserInfo')).IsAuthorizationAccount && !JSON.parse(localStorage.getItem('loginUserInfo')).IsFromEip) {
      this.$alert('沒有訪問權限', '警告', {
        confirmButtonText: '確定',
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        this.$router.back()
      })
      return false
    }
    this.getMaintenancePlan()
    this.getCategory()
    this.getSupplier()
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    async getMaintenancePlan () {
      if (this.isLoading || this.isEnd) {
        return
      }
      try {
        this.isLoading = true
        const res = await apiAsset.maintenance.getMaintenancePlan({
          params: {
            MaxCount: this.maxCount,
            Offset: this.offset
          }
        })

        const newData = res.data.map(el => {
          const startTime = dayjs(el.StartTime).format('YYYY-MM-DD')
          const endTime = dayjs(el.EndTime).format('YYYY-MM-DD')
          return {
            ...el,
            Between: `${startTime} 至 ${endTime}`,
            Categories: el.Categories.filter(el => el).join('、')
          }
        })
        const length = newData.length
        if (length < this.maxCount) {
          this.isEnd = true
        }
        this.offset += length
        await this.$sleep()
        this.listData = [...this.listData, ...newData]
        return true
      } catch (error) {
        console.log(error)
        return false
      } finally {
        this.isLoading = false
      }
    },
    handleScroll () {
      this.$handleScroll(this.getMaintenancePlan)
    },
    // 取得資產類型
    getCategory () {
      apiAsset.Asset.GetCategory()
        .then(res => {
          this.originalCategoryList = res.data
          const mainCategory = this.assetFilter[0].options
          this.originalCategoryList.forEach(item => {
            if (!item.ParentId) {
              mainCategory.push({
                label: item.Name,
                value: item.Id,
                children: []
              })
            }
          })
          this.originalCategoryList.forEach(item => {
            if (item.ParentId && item.Name) {
              const index = mainCategory.findIndex(mainItem => mainItem.value === item.ParentId)
              mainCategory[index].children.push({
                label: item.Name,
                value: item.Id
              })
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 取得廠商
    getSupplier () {
      return new Promise((resolve, reject) => {
        apiAsset.maintenance.getSupplierListWithPlan()
          .then(res => {
            this.supplierList = res.data.map(item => {
              return {
                label: item.SupplierName,
                value: item.SupplierId
              }
            })
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject(new Error('取得廠商資料失敗'))
          })
      })
    },
    onSelectSupplier (selectSupplierId) {
      this.$refs.supplierQrCodeDialog.genQRCodeBySupplierId(selectSupplierId)
    },
    clickGetQRCode () {
      this.$refs.chooseSupplierDialog.dialogVisible = true
    },
    clickBudget () {
      this.$refs.maintenanceYearDialog.dialogVisible = true
    },
    clickAdd () {
      this.$router.push({
        name: 'maintenanceProjectDetail'
      })
    },
    clickView (planId) {
      this.$router.push({
        name: 'maintenanceProjectDetailWithPlanId',
        params: {
          planId
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
#maintenanceList
  text-align: center
  height: 100%
  .title_bar
    .right button
      margin-left: 16px
    display: flex
    justify-content: space-between
    align-items: center
    margin: 20px 0
  .title_bar.center
    margin: 20px 0 10px 0
  .newslist
    font-size: 15px
    ::v-deep .el-table
      +basicTable
    .noWordBreak
      word-wrap: break-word
    .status
      color: $subFontColor
    .status-danger
      color: $dangerColor
    .assetLink
      color: $mainColorDark
      cursor: pointer
      text-decoration: underline
  .promptText
    margin: 25px 0px 0px 0px
    font-size: 20px
    +LoadingEffect

</style>
